import { React, useEffect, useState } from "react";
import KeyboardArrowRightIcon from "@mui/icons-material/ArrowForwardIos";
import MDTypography from "components/MDTypography";
import { TextField } from "@mui/material";
import PropTypes from "prop-types";
function MultiSelectTreeView(props) {
  const [searchTerm, setSearchTerm] = useState("");
  useEffect(() => {
    // Toggle Nav
    const toggler = document.getElementsByClassName("caret");

    // Convert HTMLCollection to an array
    const togglerArray = Array.from(toggler);

    for (const element of togglerArray) {
      element.addEventListener("click", function (event) {
        const nested =
          event.currentTarget.parentElement.querySelector(".nested");
        if (nested) {
          // Check if nested is not null
          nested.classList.toggle("active");
        }
        event.currentTarget.classList.toggle("caret-down");
      });
    }
  }, []);

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    props.searchedData(e.target.value);
  };

  return (
    <>
      <TextField
        className="outlined-basic-subject search-doc my-2"
        placeholder="Search docs..."
        value={searchTerm}
        onChange={handleInputChange}
        autoComplete="off"
      />
      {props.titleNode}
      <MDTypography
        variant="p"
        fontSize="13px"
        fontWeight="regular"
        fontFamily="inherit"
        color="white"
      >
        <ul className="docs-nav">
          {/* <li><a href="#account-opening-api-specifications"><MDTypography variant="h6" fontSize="13px" fontWeight="regular" fontFamily="inherit">Account Opening API Specifications</MDTypography></a></li>
                    <li><a href="#uat-environment-v4.7"><MDTypography variant="h6" fontSize="13px" fontWeight="regular" fontFamily="inherit">(UAT Environment v4.7)</MDTypography></a></li> */}
          <li>
            <a href="#introduction">
              <MDTypography
                variant="h6"
                fontSize="13px"
                fontWeight="regular"
                fontFamily="inherit"
              >
                <div data-to-scrollspy-id="introduction">Introduction</div>
              </MDTypography>
            </a>
          </li>
          <li>
            <a href="#environment ">
              <MDTypography
                variant="h6"
                fontSize="13px"
                fontWeight="regular"
                fontFamily="inherit"
              >
                <div data-to-scrollspy-id="environment">Environment</div>
              </MDTypography>
            </a>
          </li>
          <li>
            <span className="caret">
              <a href="#the-flow-of-account-opening-apis">
                <MDTypography
                  variant="h6"
                  fontSize="13px"
                  fontWeight="regular"
                  fontFamily="inherit"
                >
                  <div data-to-scrollspy-id="the-flow-of-account-opening-apis">
                    The Flow of Account Opening APIs
                    <KeyboardArrowRightIcon />
                  </div>
                </MDTypography>
              </a>
            </span>
            <ul className="nested">
              <li>
                <a href="#company-organization-llcflow">
                  <MDTypography
                    variant="h6"
                    fontSize="13px"
                    fontWeight="regular"
                    fontFamily="inherit"
                  >
                    <div data-to-scrollspy-id="company-organization-llcflow">
                      Company / Organization / LLC Flow
                    </div>
                  </MDTypography>
                </a>
              </li>
              <li>
                <a href="#individual-user-flow-and-joint-account-flow">
                  <MDTypography
                    variant="h6"
                    fontSize="13px"
                    fontWeight="regular"
                    fontFamily="inherit"
                  >
                    <div data-to-scrollspy-id="individual-user-flow-and-joint-account-flow">
                      Individual User Flow and Joint Account Flow
                    </div>
                  </MDTypography>
                </a>
              </li>
              <li>
                <a href="#overall-application-flow">
                  <MDTypography
                    variant="h6"
                    fontSize="13px"
                    fontWeight="regular"
                    fontFamily="inherit"
                  >
                    <div data-to-scrollspy-id="overall-application-flow">
                      Overall Application Flow
                    </div>
                  </MDTypography>
                </a>
              </li>
            </ul>
          </li>
          <li>
            <span className="caret">
              <a href="#api-specifications">
                <MDTypography
                  variant="h6"
                  fontSize="13px"
                  fontWeight="regular"
                  fontFamily="inherit"
                >
                  <div data-to-scrollspy-id="api-specifications">
                    API Specifications
                    <KeyboardArrowRightIcon />
                  </div>
                </MDTypography>
              </a>
            </span>
            <ul className="nested">
              <li>
                <span className="caret">
                  <a href="#token-connect">
                    <MDTypography
                      variant="h6"
                      fontSize="13px"
                      fontWeight="regular"
                      fontFamily="inherit"
                    >
                      <div data-to-scrollspy-id="token-connect">
                        Token Connect <KeyboardArrowRightIcon />
                      </div>
                    </MDTypography>
                  </a>
                </span>
                <ul className="nested">
                  <li>
                    <a href="#token-connect-login-url">
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Login API
                        </MDTypography>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#token-connect-route-url">
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Route URL
                        </MDTypography>
                      </span>
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <span className="caret">
                  <a href="#company-organization-llcapis">
                    <MDTypography
                      variant="h6"
                      fontSize="13px"
                      fontWeight="regular"
                      fontFamily="inherit"
                    >
                      <div data-to-scrollspy-id="company-organization-llcapis">
                        Company/Organization/LLC APIs
                        <KeyboardArrowRightIcon />
                      </div>
                    </MDTypography>
                  </a>
                </span>
                <ul className="nested">
                  <li>
                    <a href="#company-initial-information-api">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="company-initial-information-api">
                          Company Initial Information API
                        </div>
                      </MDTypography>
                    </a>
                  </li>
                  <li>
                    <a href="#company-beneficiary-user-information-api">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="company-beneficiary-user-information-api">
                          Company Beneficiary User Information API{" "}
                        </div>
                      </MDTypography>
                    </a>
                  </li>
                  <li>
                    <a href="#company-account-funding-api">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="company-account-funding-api">
                          Company Account Funding API{" "}
                        </div>
                      </MDTypography>
                    </a>
                  </li>
                  <li>
                    <a href="#company-other-data-api">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="company-other-data-api">
                          Company Other Data API{" "}
                        </div>
                      </MDTypography>
                    </a>
                  </li>
                  <li>
                    <a href="#company-update-api">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="company-update-api">
                          Company Update API{" "}
                        </div>
                      </MDTypography>
                    </a>
                  </li>
                  <li>
                    <a href="#company-otp-api">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="company-otp-api">
                          Company OTP API
                        </div>
                      </MDTypography>
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <span className="caret">
                  <a href="#individual-user-iu-joint-account-ja-signup-apis">
                    <MDTypography
                      variant="h6"
                      fontSize="13px"
                      fontWeight="regular"
                      fontFamily="inherit"
                    >
                      <div data-to-scrollspy-id="individual-user-iu-joint-account-ja-signup-apis">
                        Individual User (IU)/Joint Account (JA) (Signup) APIs
                        <KeyboardArrowRightIcon />
                      </div>
                    </MDTypography>
                  </a>
                </span>
                <ul className="nested">
                  <li>
                    <a href="#iu-ja-signup-initial-information-api">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="iu-ja-signup-initial-information-api">
                          IU/JA Signup Initial Information API{" "}
                        </div>
                      </MDTypography>
                    </a>
                  </li>
                  <li>
                    <a href="#iu-ja-signup-account-funding-api">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="iu-ja-signup-account-funding-api">
                          IU/JA Signup Account Funding API{" "}
                        </div>
                      </MDTypography>
                    </a>
                  </li>
                  <li>
                    <a href="#iu-ja-signup-other-data-api">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="iu-ja-signup-other-data-api">
                          IU/JA Signup Other Data API
                        </div>
                      </MDTypography>
                    </a>
                  </li>
                  <li>
                    <a href="#iu-ja-signup-update-api">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="iu-ja-signup-update-api">
                          IU/JA Signup Update API{" "}
                        </div>
                      </MDTypography>
                    </a>
                  </li>
                  <li>
                    <a href="#iu-ja-signup-otp-api">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="iu-ja-signup-otp-api">
                          IU/JA Signup OTP API
                        </div>
                      </MDTypography>
                    </a>
                  </li>
                  <li>
                    <a href="#iu-ja-all-accounts-api">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="iu-ja-all-accounts-api">
                          IU/JA All Accounts API{" "}
                        </div>
                      </MDTypography>
                    </a>
                  </li>
                  <li>
                    <a href="#iu-ja-filter-accounts-api">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="iu-ja-filter-accounts-api">
                          IU/JA Filter Accounts API
                        </div>
                      </MDTypography>
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <span className="caret">
                  <a href="#disclosure-documents-apis">
                    <MDTypography
                      variant="h6"
                      fontSize="13px"
                      fontWeight="regular"
                      fontFamily="inherit"
                    >
                      <div data-to-scrollspy-id="disclosure-documents-apis">
                        Disclosure Documents APIs
                        <KeyboardArrowRightIcon />
                      </div>
                    </MDTypography>
                  </a>
                </span>
                <ul className="nested">
                  <li>
                    <span className="caret">
                      <a href="#disclosure-documents-apis-list-all">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          <div data-to-scrollspy-id="disclosure-documents-apis-list-all">
                            List All
                            <KeyboardArrowRightIcon />
                          </div>
                        </MDTypography>
                      </a>
                    </span>
                    <ul className="nested">
                      <li>
                        <a href="#get-specific-document">
                          <span className="caret">
                            <MDTypography
                              variant="h6"
                              fontSize="13px"
                              fontWeight="regular"
                              fontFamily="inherit"
                            >
                              <div data-to-scrollspy-id="get-specific-document">
                                Get Specific Document
                              </div>
                            </MDTypography>
                          </span>
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <span className="caret">
                  <a href="#api-options">
                    <MDTypography
                      variant="h6"
                      fontSize="13px"
                      fontWeight="regular"
                      fontFamily="inherit"
                    >
                      <div data-to-scrollspy-id="api-options">
                        API Options
                        <KeyboardArrowRightIcon />
                      </div>
                    </MDTypography>
                  </a>
                </span>
                <ul className="nested">
                  <li>
                    <span className="caret">
                      <a href="#api-options-list-all">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          <div data-to-scrollspy-id="api-options-list-all">
                            List All
                            <KeyboardArrowRightIcon />
                          </div>
                        </MDTypography>
                      </a>
                    </span>
                    <ul className="nested">
                      <li>
                        <a href="#get-option-details">
                          <span className="caret">
                            <MDTypography
                              variant="h6"
                              fontSize="13px"
                              fontWeight="regular"
                              fontFamily="inherit"
                            >
                              <div data-to-scrollspy-id="get-option-details">
                                Get Option Details
                              </div>
                            </MDTypography>
                          </span>
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <span className="caret">
              <a href="#sample-data-encryption">
                <MDTypography
                  variant="h6"
                  fontSize="13px"
                  fontWeight="regular"
                  fontFamily="inherit"
                >
                  <div data-to-scrollspy-id="sample-data-encryption">
                    Sample Data Encryption
                    <KeyboardArrowRightIcon />
                  </div>
                </MDTypography>
              </a>
            </span>
            <ul className="nested">
              <li>
                <a href="#encrypting-json-data">
                  <MDTypography
                    variant="h6"
                    fontSize="13px"
                    fontWeight="regular"
                    fontFamily="inherit"
                  >
                    <div data-to-scrollspy-id="encrypting-json-data">
                      Encrypting JSON Data
                    </div>
                  </MDTypography>
                </a>
              </li>
              <li>
                <a href="#encrypting-form-data-and-attaching-files">
                  <MDTypography
                    variant="h6"
                    fontSize="13px"
                    fontWeight="regular"
                    fontFamily="inherit"
                  >
                    <div data-to-scrollspy-id="encrypting-form-data-and-attaching-files">
                      Encrypting Form Data And Attaching Files
                    </div>
                  </MDTypography>
                </a>
              </li>
            </ul>
          </li>
          <li>
            <a href="#disclaimer-and-confidentiality-notice">
              <MDTypography
                variant="h6"
                fontSize="13px"
                fontWeight="regular"
                fontFamily="inherit"
              >
                <div data-to-scrollspy-id="encrypting-form-data-and-attaching-files">
                  Disclaimer and Confidentiality Notice
                </div>
              </MDTypography>
            </a>
          </li>
        </ul>
        <MDTypography
          variant="h6"
          fontSize="13px"
          fontWeight="medium"
          fontFamily="inherit"
          className="nav-footer"
        >
          Account Opening API - Version 4.9
        </MDTypography>
      </MDTypography>
    </>
  );
}
MultiSelectTreeView.propTypes = {
  searchedData: PropTypes.func.isRequired,
};
export default MultiSelectTreeView;
